import React from 'react'

import { Box, Typography } from '@mui/material'
import { MapPin, User } from 'lucide-react'

import Avatar from '../../../../shared/components/Avatar/Avatar.component'

import styles from './RecipientCard.styles'
import type { RecipientCardProps } from './RecipientCard.types'
import { formatDeliveryAddress, getFirstAndLastName } from './recipientCard.functions'

const RecipientCard: React.FC<RecipientCardProps> = ({ recipient }) => {
  const { firstName, lastName } = getFirstAndLastName(recipient.name)
  const address = formatDeliveryAddress(recipient)

  return (
    <Box sx={styles.card}>
      <Box sx={styles.cardHeader}>
        <Typography sx={styles.cardTitle}>Contact Details</Typography>

        <Box sx={styles.iconWrap}>
          <User size={15} color="#6D28D9" />
        </Box>
      </Box>

      <Box sx={styles.avatarRow}>
        <Avatar firstName={firstName} lastName={lastName} size="medium" noRightMargin />

        <Box>
          <Typography sx={styles.avatarName}>{recipient.name}</Typography>
          <Typography sx={styles.avatarEmail}>{recipient.email}</Typography>
        </Box>
      </Box>

      <Box sx={styles.divider} />

      <Box sx={styles.infoRow}>
        <Box sx={styles.addrIconWrap}>
          <MapPin size={15} color="#10B981" />
        </Box>

        <Box sx={styles.infoContent}>
          <Typography sx={styles.infoLabel}>Delivery Address</Typography>
          {address.line1 && <Typography sx={styles.infoPrimary}>{address.line1}</Typography>}
          {address.line2 && <Typography sx={styles.infoSecondary}>{address.line2}</Typography>}
          {address.line3 && <Typography sx={styles.infoSecondary}>{address.line3}</Typography>}
        </Box>
      </Box>
    </Box>
  )
}

export default RecipientCard
